// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MpmO","left":"styles_left__3AXqN"};